import { Component, inject } from '@angular/core';
import { IonProgressBar } from '@ionic/angular/standalone';
import { WaitEnum, WaitService } from '../../service/wait.service';
import { map, tap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-wait',
  template: `<div
    style="position: fixed; top: 0; left: 0; right: 0; z-index: 9999; height: 4px; background: transparent;"
  >
    @if (color$ | async; as color) {
      <ion-progress-bar type="indeterminate" [color]="color" mode="ios"></ion-progress-bar>
    }
  </div>`,
  imports: [IonProgressBar, AsyncPipe],
  standalone: true,
})
export class WaitComponent {
  readonly waitService = inject(WaitService);

  // Transform WaitEnum to Color | undefined
  readonly color$ = this.waitService.color$.pipe(
    tap((color) => console.log(`Color ${color}`)),
    map((color) => {
      if (!color || color === WaitEnum.undefinedColor) {
        return undefined;
      }
      // Cast enum value to string for Ionic's Color type
      return color as string as 'primary' | 'secondary';
    }),
  );
}
